import HeroBespokeV1 from './Variant1/HeroBespokeV1'
import HeroBespokeV2 from './Variant2/HeroBespokeV2'

const HeroBespoke = ({ data, breadcrumb }: HeroProps) => {
  const style = data.style

  if (style === '1')
    return <HeroBespokeV1 data={data} breadcrumb={breadcrumb} />
  if (style === '2')
    return <HeroBespokeV2 data={data} breadcrumb={breadcrumb} />
}

export default HeroBespoke
